import { useEffect, useState } from 'react'
import { classNames } from 'utils/dom-helpers'

type InputProps = {
    className?: string
    default_value: number
    disabled?: boolean
    min_value?: number
    max_value?: number
    step_value?: number
    helper_text?: string
    hide_input?: boolean
    onChange(value: number): void
}
export function StepperInput(props: InputProps) {
    const [value, setValue] = useState<number>(props.default_value || 0)
    const min_value = props.min_value || 0
    const max_value = props.max_value || 999999
    const step_value = props.step_value || 1

    function onChangeValue(value: number) {
        if (value > max_value) {
            value = max_value
        } else if (value < min_value) {
            value = min_value
        }
        setValue(value)
        props.onChange(value)
    }

    useEffect(() => {
        setValue(props.default_value || 0)
    }, [props.default_value])

    return (
        <div className="flex items-center relative">
            <input
                className={classNames(
                    props.className ||
                    'w-full focus:ring-primary-light focus:border-primary-light shadow-sm sm:text-sm border-gray-300 rounded-md',
                    props.disabled || value === min_value
                        ? 'text-gray-400 bg-gray-100'
                        : '',
                )}
                style={{
                    border: '1px solid gray',
                }}
                type="number"
                disabled={props.disabled}
                min={min_value}
                max={max_value}
                value={props.hide_input ? '' : value}
                onChange={(e) => {
                    onChangeValue(parseInt(e.target.value))
                }}
            />
            <div className="absolute right-5 flex items-center gap-1">
                <span
                    className={classNames(
                        'mr-3',
                        props.disabled ? 'text-gray-400' : ''
                    )}
                >
                    {props.helper_text}
                </span>
                <button
                    className={classNames(
                        'shadow flex items-center justify-center',
                        'right-11 w-6',
                        'bg-white border rounded',
                        props.disabled || value == min_value
                            ? 'text-gray-400 bg-gray-100 border-gray-100'
                            : 'text-primary transition duration-300 ease-in-out ' +
                            'hover:border-transparent ' +
                            'hover:bg-primary-light ' +
                            'hover:text-white '
                    )}
                    disabled={props.disabled}
                    type="button"
                    onClick={() => {
                        onChangeValue(value - step_value)
                    }}
                >
                    -
                </button>
                <button
                    className={classNames(
                        'shadow flex items-center justify-center',
                        'right-3 w-6',
                        'bg-white border rounded',
                        props.disabled
                            ? 'text-gray-400 bg-gray-100 border-gray-100'
                            : 'text-primary transition duration-300 ease-in-out ' +
                            'hover:border-transparent ' +
                            'hover:bg-primary-light ' +
                            'hover:text-white '
                    )}
                    type="button"
                    disabled={props.disabled}
                    onClick={() => {
                        onChangeValue(value + step_value)
                    }}
                >
                    +
                </button>
            </div>
        </div>
    )
}

export default StepperInput
